import { Component, OnInit, Injector, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { AnalyticsService, ApplicationInsightsService } from '@crosscutting/public_api';

import { VMRefreshSessionService } from '../services/lib/vmrefresh-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './veiligheidsmeter.app.component.html',
  styleUrls: ['./veiligheidsmeter.app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private _injector: Injector,
    private _vmRefreshSessionService: VMRefreshSessionService
  ) { }

  ngOnInit() {
    this._vmRefreshSessionService.initialize();
   
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
        window.scrollTo({top: 0, behavior: "smooth"});
        try {
          const router = this._injector.get(Router),
                results = new RegExp('[\\?&]key=([^&#]*)').exec(router.url);

          if (results == null) {
            const analyticsService = this._injector.get(AnalyticsService),
                  applicationInsightsService = this._injector.get(ApplicationInsightsService);

            let path = '/cybercheck';

            analyticsService.googleEmitPageview(path);
            applicationInsightsService.logPageView(null, path);
          }
          this._vmRefreshSessionService.updateSessionTimeout();
        } catch { }
      }
    });
  }
}
